<div class="svg-icon">
    <ng-container [ngSwitch]="svg">
        <!-- Symbology icons -->
        <ng-container *ngSwitchCase="'symbol_24-geom-point'">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle [attr.fill]="color" [attr.stroke]="outlineColor" cx="12" cy="12" r="4.5" />
            </svg>
        </ng-container>

        <ng-container *ngSwitchCase="'symbol_24-geom-line'">
            <svg width="24" height="2" viewBox="0 0 24 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path [attr.stroke]="color" d="M0 1H24" stroke-width="2" />
            </svg>
        </ng-container>

        <ng-container *ngSwitchCase="'symbol_24-geom-poly'">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2 9L12 2L23 9L16 22H2V20Z"
                    [attr.fill-opacity]="polygonOpacity * 0.01"
                    [attr.fill]="color"
                    [attr.stroke]="outlineColor"
                />
                <rect x="15" y="20.5" width="3" height="3" [attr.fill]="color" />
                <rect x="0.4" y="7.5" width="3" height="3" [attr.fill]="color" />
                <rect x="21.2" y="7.5" width="3" height="3" [attr.fill]="color" />
                <rect x="10.5" y="0.7" width="3" height="3" [attr.fill]="color" />
                <rect x="0.4" y="20.5" width="3" height="3" [attr.fill]="color" />
            </svg>
        </ng-container>

        <ng-container *ngSwitchCase="'symbol_24-geom-none'">
            <svg x="0px" y="0px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                <path
                    [attr.fill]="'#363545'"
                    d="M28.5,26.5V25c0-1.1,0.2-2.1,0.7-2.8c0.5-0.8,1.3-1.5,2.4-2.2c0.9-0.6,1.6-1.1,2-1.6s0.6-1,0.6-1.6
		c0-0.5-0.2-0.9-0.6-1.1c-0.4-0.3-1-0.4-1.7-0.4c-1.7,0-3.7,0.6-6,1.8l-2.4-4.6c2.8-1.6,5.8-2.4,8.9-2.4c2.5,0,4.5,0.6,6,1.7
		c1.4,1.1,2.2,2.6,2.2,4.5c0,1.4-0.3,2.6-1,3.6c-0.6,1-1.7,2-3.1,2.9c-1.2,0.8-1.9,1.3-2.2,1.7s-0.5,0.8-0.5,1.3v0.9H28.5z
		 M27.8,32.4c0-1,0.3-1.8,0.9-2.4c0.6-0.6,1.5-0.9,2.7-0.9c1.1,0,2,0.3,2.6,0.9c0.6,0.6,0.9,1.4,0.9,2.4s-0.3,1.8-0.9,2.4
		c-0.6,0.6-1.5,0.9-2.6,0.9c-1.1,0-2-0.3-2.6-0.8C28.1,34.3,27.8,33.5,27.8,32.4z"
                />
            </svg>
        </ng-container>

        <!-- Symbology icon preview thumbnails-->

        <ng-container *ngSwitchCase="'symbol_24-preview-point'">
            <div class="point-geometry-symbol" [innerHTML]="svgIconImage"></div>
        </ng-container>

        <ng-container *ngSwitchCase="'symbol_24-preview-line'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" class="line-area">
                <path *ngIf="lineStyle === LineStyle.SOLID" [attr.stroke]="color" d="M14 20H50" stroke-width="4" />
                <path
                    *ngIf="lineStyle === LineStyle.DASHED"
                    [attr.stroke]="color"
                    d="M14 20H50"
                    stroke-width="4"
                    stroke-dasharray="7 3"
                />
                <path
                    *ngIf="lineStyle === LineStyle.DOTTED"
                    [attr.stroke]="color"
                    d="M14 20H50"
                    stroke-width="4"
                    stroke-dasharray="2 6"
                />
                <ng-container *ngIf="addLayerBasePolygon">
                    <polygon
                        opacity="0.1"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        fill="#363545"
                        points="6,38 6,31.3 32,19 58,31.3 58,38 32,26 "
                    />
                    <polygon
                        opacity="0.3"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        fill="#363545"
                        points="6,31 6,37.7 32,50 58,37.7 58,31 32,43 "
                    />
                </ng-container>
            </svg>
        </ng-container>

        <ng-container *ngSwitchCase="'symbol_24-preview-poly'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" class="line-area">
                <ng-container *ngIf="addLayerBasePolygon">
                    <polygon
                        opacity="0.1"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        fill="#363545"
                        points="6,38 6,31.3 32,19 58,31.3 58,38 32,26 "
                    />
                    <polygon
                        opacity="0.3"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        fill="#363545"
                        points="6,31 6,37.7 32,50 58,37.7 58,31 32,43 "
                    />
                </ng-container>

                <path
                    *ngIf="lineStyle === LineStyle.SOLID"
                    [attr.fill]="color"
                    [attr.stroke]="outlineColor"
                    d="M19.5 15.5L36.5 7.5L47.5 15.5L40.5 36.5H19.5V15.5Z"
                    stroke-width="2"
                    [attr.fill-opacity]="polygonOpacity * 0.01"
                />
                <path
                    *ngIf="lineStyle === LineStyle.DASHED"
                    [attr.fill]="color"
                    [attr.stroke]="outlineColor"
                    d="M19.5 15.5L36.5 7.5L47.5 15.5L40.5 36.5H19.5V15.5Z"
                    stroke-width="2"
                    [attr.fill-opacity]="polygonOpacity * 0.01"
                    stroke-dasharray="5 3"
                />
                <path
                    *ngIf="lineStyle === LineStyle.DOTTED"
                    [attr.fill]="color"
                    [attr.stroke]="outlineColor"
                    d="M19.5 15.5L36.5 7.5L47.5 15.5L40.5 36.5H19.5V15.5Z"
                    stroke-width="2"
                    [attr.fill-opacity]="polygonOpacity * 0.01"
                    stroke-dasharray="2 2"
                />
                <rect x="17.5" y="13.5" width="4" height="4" [attr.fill]="outlineColor" />
                <rect x="34.5" y="5.5" width="4" height="4" [attr.fill]="outlineColor" />
                <rect x="45.5" y="13.5" width="4" height="4" [attr.fill]="outlineColor" />
                <rect x="38.5" y="34.5" width="4" height="4" [attr.fill]="outlineColor" />
                <rect x="17.5" y="34.5" width="4" height="4" [attr.fill]="outlineColor" />
            </svg>
        </ng-container>

        <ng-container *ngSwitchCase="'symbol_24-preview-plane'">
            <svg x="0px" y="0px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                <polygon
                    opacity="0.1"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    [attr.fill]="'#363545'"
                    points="6,38 6,31.3 32,19 58,31.3 58,38 32,26 "
                />
                <polygon
                    opacity="0.3"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    [attr.fill]="'#363545'"
                    points="6,31 6,37.7 32,50 58,37.7 58,31 32,43 "
                />
            </svg>
        </ng-container>

        <ng-container *ngSwitchCase="'symbol_24-preview-none'">
            <svg x="0px" y="0px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                <polygon
                    opacity="0.1"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    [attr.fill]="'#363545'"
                    points="6,38 6,31.3 32,19 58,31.3 58,38 32,26 "
                />
                <polygon
                    opacity="0.3"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    [attr.fill]="'#363545'"
                    points="6,31 6,37.7 32,50 58,37.7 58,31 32,43 "
                />
                <path
                    [attr.fill]="'#363545'"
                    d="M28.5,26.5V25c0-1.1,0.2-2.1,0.7-2.8c0.5-0.8,1.3-1.5,2.4-2.2c0.9-0.6,1.6-1.1,2-1.6s0.6-1,0.6-1.6
		c0-0.5-0.2-0.9-0.6-1.1c-0.4-0.3-1-0.4-1.7-0.4c-1.7,0-3.7,0.6-6,1.8l-2.4-4.6c2.8-1.6,5.8-2.4,8.9-2.4c2.5,0,4.5,0.6,6,1.7
		c1.4,1.1,2.2,2.6,2.2,4.5c0,1.4-0.3,2.6-1,3.6c-0.6,1-1.7,2-3.1,2.9c-1.2,0.8-1.9,1.3-2.2,1.7s-0.5,0.8-0.5,1.3v0.9H28.5z
		 M27.8,32.4c0-1,0.3-1.8,0.9-2.4c0.6-0.6,1.5-0.9,2.7-0.9c1.1,0,2,0.3,2.6,0.9c0.6,0.6,0.9,1.4,0.9,2.4s-0.3,1.8-0.9,2.4
		c-0.6,0.6-1.5,0.9-2.6,0.9c-1.1,0-2-0.3-2.6-0.8C28.1,34.3,27.8,33.5,27.8,32.4z"
                />
            </svg>
        </ng-container>

        <ng-container *ngSwitchCase="'symbol_24-preview-collection'">
            <svg x="0px" y="0px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" xml:space="preserve">
                <polygon
                    opacity="0.1"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    [attr.fill]="'#363545'"
                    points="6,38 6,31.3 32,19 58,31.3 58,38 32,26 "
                />
                <polygon
                    opacity="0.3"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    [attr.fill]="'#363545'"
                    points="6,31 6,37.7 32,50 58,37.7 58,31 32,43 "
                />
                <circle fill-rule="evenodd" clip-rule="evenodd" [attr.fill]="color" cx="34.6" cy="8.4" r="3.4" />
                <path
                    [attr.fill]="color"
                    d="M50.3,17c-0.4,0.1-0.7,0.3-1,0.6l-4.5-2.2c0-0.4,0-0.8-0.1-1.2c-0.5-1.6-2.2-2.4-3.8-1.9
	c-1.6,0.5-2.4,2.2-1.9,3.8c0.5,1.6,2.2,2.4,3.8,1.9c0.4-0.1,0.7-0.3,1-0.6l4.5,2.2c0,0.4,0,0.8,0.1,1.2c0.1,0.2,0.2,0.4,0.3,0.6
	l-4.3,6c-0.5-0.1-1.1-0.1-1.7,0.1c-1.6,0.5-2.4,2.2-1.9,3.8c0.5,1.6,2.2,2.4,3.8,1.9s2.4-2.2,1.9-3.8c-0.1-0.2-0.2-0.4-0.3-0.6
	l4.3-6c0.5,0.1,1.1,0.1,1.7-0.1c1.6-0.5,2.4-2.2,1.9-3.8C53.6,17.4,51.9,16.5,50.3,17z"
                />
                <polygon
                    opacity="0.5"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    [attr.fill]="color"
                    points="29.7,17.6 40.2,23.6 32.7,32.6 21.5,32.6 21.5,23.6 "
                />
                <path
                    [attr.fill]="color"
                    d="M41,19.8c-0.8,0-1.5,0.3-2,0.8l-5.6-3.2c0-0.2,0.1-0.3,0.1-0.5c0-1.7-1.3-3-3-3s-3,1.3-3,3c0,0.2,0,0.3,0,0.5
	l-4.5,3c-0.4-0.3-1-0.4-1.5-0.4c-1.7,0-3.5,1.3-3.5,3c0,1.1,1,2.1,1,2.6v5.3c0,0.5-1,1.5-1,2.6c0,1.7,1.6,2.6,3.2,2.6
	c1.1,0,2.3-0.9,2.8-1.9h6.8c0.5,1,1.5,1.9,2.6,1.9c1.7,0,3-1.1,3-2.8c0-0.5-0.1-0.9-0.4-1.3l4.3-6.1c0.2,0,0.4,0.1,0.6,0.1
	c1.7,0,3-1.3,3-3C44,21.2,42.6,19.8,41,19.8z M33.5,30c-1.4,0-2.6,1-2.9,2h-6.2c-0.3-1-1.4-1.3-2.4-1.6v-4.7c1-0.3,2.4-1.5,2.4-2.9
	c0-0.3,0-0.5-0.1-0.8l4.4-2.8c0.5,0.4,1.1,0.6,1.8,0.6c0.7,0,1.3-0.2,1.8-0.6l5.8,3.4c0,0.1,0,0.1,0,0.2c0,0.6,0.2,1.2,0.5,1.7
	l-4.1,5.8C34.1,30.2,33.8,30,33.5,30z"
                />
            </svg>
        </ng-container>

        <ng-container *ngSwitchDefault>
            <svg x="0px" y="0px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
                <path
                    [attr.fill]="'#363545'"
                    d="M28.5,26.5V25c0-1.1,0.2-2.1,0.7-2.8c0.5-0.8,1.3-1.5,2.4-2.2c0.9-0.6,1.6-1.1,2-1.6s0.6-1,0.6-1.6
		c0-0.5-0.2-0.9-0.6-1.1c-0.4-0.3-1-0.4-1.7-0.4c-1.7,0-3.7,0.6-6,1.8l-2.4-4.6c2.8-1.6,5.8-2.4,8.9-2.4c2.5,0,4.5,0.6,6,1.7
		c1.4,1.1,2.2,2.6,2.2,4.5c0,1.4-0.3,2.6-1,3.6c-0.6,1-1.7,2-3.1,2.9c-1.2,0.8-1.9,1.3-2.2,1.7s-0.5,0.8-0.5,1.3v0.9H28.5z
		 M27.8,32.4c0-1,0.3-1.8,0.9-2.4c0.6-0.6,1.5-0.9,2.7-0.9c1.1,0,2,0.3,2.6,0.9c0.6,0.6,0.9,1.4,0.9,2.4s-0.3,1.8-0.9,2.4
		c-0.6,0.6-1.5,0.9-2.6,0.9c-1.1,0-2-0.3-2.6-0.8C28.1,34.3,27.8,33.5,27.8,32.4z"
                />
            </svg>
        </ng-container>
    </ng-container>
</div>
